import axios from 'axios';
import Cookies from 'js-cookie';
import Config from '../../config';
import ConstantApi from '../../ConstantApi';
import { fetchPropertyDataForAccessoriesMaster } from '../accessoriesMaster/accessoriesMaster.actions';
import axiosCall from '../axiosCall';
import {
    FETCH_SINGLE_ACCESSORIES_USAGE_REQUEST,
    FETCH_SINGLE_ACCESSORIES_USAGE_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_USAGE_FAILURE,
    FETCH_ACCESSORIES_USAGE_REQUEST,
    CREATE_ACCESSORIES_USAGE_FORM,
    FETCH_ACCESSORIES_USAGE_SUCCESS,
    FETCH_ACCESSORIES_USAGE_FAILURE,
    CREATE_ACCESSORIES_USAGE_REQUEST,
    CREATE_ACCESSORIES_USAGE_SUCCESS,
    CREATE_ACCESSORIES_USAGE_FAILURE,
    RESET_ACCESSORIES_USAGE_INFO,
    UPDATE_ACCESSORIES_USAGE_REQUEST,
    UPDATE_ACCESSORIES_USAGE_SUCCESS,
    UPDATE_ACCESSORIES_USAGE_FAILURE,
    DELETE_ACCESSORIES_USAGE_REQUEST,
    DELETE_ACCESSORIES_USAGE_SUCCESS,
    DELETE_ACCESSORIES_USAGE_FAILURE
} from './accessoriesUsage.actionsType';
import { fetchCommonPropertyById } from '../property/common/commonProperty.actions';

// FETCH ACCESSORIES_USAGE DATA
export let fetchAccessoriesUsageDetails = () => {
    let config = {
        method: 'get',
        url: ConstantApi.accessoriesUsageGET,
        responseTypeRequest: FETCH_ACCESSORIES_USAGE_REQUEST,
        responseTypeSuccess: FETCH_ACCESSORIES_USAGE_SUCCESS,
        responseTypeFailure: FETCH_ACCESSORIES_USAGE_FAILURE
    };
    return axiosCall(config);
};

// CREATE ACCESSORIES_USAGE FORM
export let createAccessoriesUsageForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_ACCESSORIES_USAGE_FORM, payload: { key, value } });
    };
};

// CREATE ACCESSORIES_USAGE
export let createAccessoriesUsage = (formData2, modalClose) => {
    let formData = formData2;
    delete formData['excessType'];
    delete formData['usageType'];
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        ...formData,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        // fldFKCategory: parseInt(formData.fldFKCategory),
        fldExcessValue: formData.fldExcessValue
            ? formData.fldExcessValue.split('.').length >= 2
                ? parseFloat(formData.fldExcessValue)
                : parseInt(formData.fldExcessValue)
            : 0
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.accessoriesUsagePOST}`,
        responseTypeRequest: CREATE_ACCESSORIES_USAGE_REQUEST,
        responseTypeSuccess: CREATE_ACCESSORIES_USAGE_SUCCESS,
        responseTypeFailure: CREATE_ACCESSORIES_USAGE_FAILURE,
        resetFormData: RESET_ACCESSORIES_USAGE_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchAccessoriesUsageDetails()
    };
    return axiosCall(config);
};

// GET SINGLE ACCESSORIES_USAGE
export let getSingleAccessoriesUsage = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_SINGLE_ACCESSORIES_USAGE_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}/api/TblAccessoriesUsage/GetTblAccessoriesUsage/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                let data = response.data;
                if (response?.data?.fldUsagetypeQuanity) {
                    data['usageType'] = 'fldUsagetypeQuanity';
                } else if (response?.data.fldUsagetypePerval) {
                    data['usageType'] = 'fldUsagetypePerval';
                } else if (response?.data?.fldUsagetypeNR) {
                    data['usageType'] = 'fldUsagetypeNR';
                }
                if (response?.data?.fldExcessTypePerval) {
                    data['excessType'] = 'fldExcessTypePerval';
                } else if (response?.data?.fldExcessTypeUnit) {
                    data['excessType'] = 'fldExcessTypeUnit';
                }
                dispatch({ type: FETCH_SINGLE_ACCESSORIES_USAGE_SUCCESS, payload: data });
                dispatch(fetchCommonPropertyById(43));
            })
            .catch((error) => {
                dispatch({ type: FETCH_SINGLE_ACCESSORIES_USAGE_FAILURE, payload: error });
            });
    };
};

//UPDATE ACCESSORIES_USAGE
export let updateAccessoriesUsage = (formData2) => {
    let formData = formData2;
    delete formData['excessType'];
    delete formData['usageType'];
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedDt: today.toISOString(),
        // fldFKCategory: parseInt(formData.fldFKCategory),
        fldExcessValue: formData.fldExcessValue
            ? formData.fldExcessValue.split('.').length >= 2
                ? parseFloat(formData.fldExcessValue)
                : parseInt(formData.fldExcessValue)
            : 0
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.accessoriesUsagePATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_ACCESSORIES_USAGE_REQUEST,
        responseTypeSuccess: UPDATE_ACCESSORIES_USAGE_SUCCESS,
        responseTypeFailure: UPDATE_ACCESSORIES_USAGE_FAILURE,
        resetFormData: RESET_ACCESSORIES_USAGE_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchAccessoriesUsageDetails()
    };
    return axiosCall(config);
};

// DELETE ACCESSORIES_USAGE
export let deleteAccessoriesUsage = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.accessoriesUsageDELETE}/${id}`,
        responseTypeRequest: DELETE_ACCESSORIES_USAGE_REQUEST,
        responseTypeSuccess: DELETE_ACCESSORIES_USAGE_SUCCESS,
        responseTypeFailure: DELETE_ACCESSORIES_USAGE_FAILURE,
        modalClose: true,
        getAllData: fetchAccessoriesUsageDetails()
    };
    return axiosCall(config);
};
